import { watchEffect } from 'vue';
import { createI18n } from 'vue-i18n';
import en from './en.json';
import zh from './zh.json';

// 默认语言
export const defaultLang = 'zh';

const langArr = ['en', 'zh'];

let i18n;
watchEffect(() => {
    console.log("进入了")
  let lang = localStorage.getItem('lang') || '';

  const existInx = langArr.findIndex((item) => item === lang);
  // if (existInx === -1) {
  //   localStorage.removeItem('lang');
  // } else {
  //   document.body.className = 'lang-' + lang;
  // }

  i18n = createI18n({
    fallbackLocale: defaultLang,
    globalInjection: true,
    legacy: false, // you must specify 'legacy: false' option
    locale: lang || defaultLang,
    missingWarn: true,
    warnHtmlMessage: 'off',
    fallbackWarn: false,
    messages: {
      en,
      zh,
    },
  });
});

export default i18n;
